import React, { useState } from 'react'
// import { supabase } from '../supabase/client';
// import { useNavigate } from "react-router-dom";
import { useLogin } from '../context/LoginContext';

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    
    const { signInMail, error } = useLogin();

    // const navigate = useNavigate();

    // const handleUsernameChange = (e) => {
    //     setUsername(e.target.value);
    // };

    // const handlePasswordChange = (e) => {
    //     setPassword(e.target.value);
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        signInMail({ email, password });

        // try {
        //     const { error } = await supabase.auth.signInWithPassword({
        //         email: email,
        //         password: password,
        //     })
        //     setError(error?.message)
        // } catch (error) {
        //     console.error(error);
        // }
        // Validación adicional para el número de 8 dígitos
        // const isValidUsername = /^[0-9]{8}$/.test(username);

        // if (!isValidUsername) {
        //     setError('El usuario debe ser un número de 8 dígitos');
        //     return;
        // }


        // try {
        //     const formData = new FormData();
        //     formData.append('username', username);
        //     formData.append('password', password);

        //     const response = await fetch('http://localhost:8080/auth/login', {
        //         method: 'POST',
        //         body: formData,
        //     });

        //     if (response.ok) {
        //         const data = await response.json();
        //         const token = data.token;
        //         console.log(token);
        //         navigate("/");
        //     } else {
        //         setError('Error al iniciar sesión');
        //     }
        // } catch (error) {
        //     setError('Error al conectar con el servidor');
        // }

        // setError('');
        // setUsername('');
        // setPassword('');
    };
    return (
        <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 w-1/3">
            <div className="mb-4">
                <label
                    className="block text-gray-700 text-sm mb-2"
                    htmlFor="username"
                >
                    Usuario
                </label>
                <input
                    className="shadow appearance-none text-sm border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    name="username"
                    type="email"
                    placeholder="Ingrese su email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div className="mb-6">
                <label
                    className="block text-gray-700 text-sm mb-2"
                    htmlFor="password"
                >
                    Contraseña
                </label>
                <input
                    className="shadow appearance-none text-sm border w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                    name="password"
                    type="password"
                    placeholder="Ingrese su contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>}
            <div className="flex items-center justify-between">
                <button
                    className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 text-base  focus:outline-none focus:shadow-outline"
                    type="button"
                    onClick={handleSubmit}
                >
                    Iniciar sesión
                </button>
            </div>
        </form>
    )
}

export default LoginForm